import { css } from "@emotion/react"

import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import alertIcon from "../../../components/ui/ErrorText/alert.svg"

type Props = {
  message: string
  passwordResetLink: string
}

const AccountLockedMessage = ({ message, passwordResetLink }: Props) => {
  return (
    <p css={styles.base}>
      <Image src={alertIcon} alt="" css={styles.icon} width={14} height={14} role="presentation" clearExtraSpace />
      <Spacer size={5} />
      <span>
        {message}
        <br />
        <a href={passwordResetLink} css={styles.link} target="_blank" rel="noopener noreferrer">
          こちら
        </a>
        からパスワードを再発行してください。
      </span>
    </p>
  )
}

export default AccountLockedMessage

const styles = {
  base: css`
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #c50d12;
  `,
  icon: css`
    position: relative;
    bottom: 1px;
  `,
  link: css`
    color: #16a34a;
    font-weight: bold;
    text-decoration: underline;
  `,
}
